// API Configuration
export const API_CONFIG = {
  // Always use direct API URL
  API_URL: 'https://api.secureroom.ai/api',
  BASE_URL: 'https://api.secureroom.ai',

  // Timeout configuration
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),

  // Retry configuration
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,

  // Rate limiting
  RATE_LIMIT_WINDOW: 60000, // 1 minute
  RATE_LIMIT_MAX_REQUESTS: 100,
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  const apiUrl = API_CONFIG.API_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${apiUrl}${cleanEndpoint}`;
};

// Export for backward compatibility
export const API_URL = API_CONFIG.API_URL;
export const BASE_URL = API_CONFIG.BASE_URL;

export default API_CONFIG;